import React from 'react';
import {useTranslation} from 'react-i18next';
import {isEmpty} from 'lodash';
import {Controller, useFormContext} from 'react-hook-form';
import {usePaymentSettings} from '../../../hooks';
import {UNIT_PRICE_LABELS, QUANTITY_LABELS} from '../constants';
import {FORM_NAMES, FormTypes, ItemsFieldsNames} from './UpsellingOrderForm';
import {PriceItem} from '../../../utils/upselling/types';
import {PriceFormsProps} from './types';
import {UNIT_PRICE_TYPES} from 'utils/upselling';
import {ControlledCounter} from '../../../components/acommon/Counter';
import {OrderRow} from './styled';

function SinglePriceForm({offerData, disabled}: PriceFormsProps) {
  const {price, unit_type} = offerData?.items[0] || offerData;
  const {paymentSettingsCurrencySign: currency} = usePaymentSettings();
  const {control, getValues, setValue} = useFormContext<
    FormTypes & Record<string, any>
  >();
  const {t} = useTranslation();
  const quantitySingleFieldName = `${FORM_NAMES.items}.0.${ItemsFieldsNames.quantity}`;

  React.useEffect(() => {
    const preloaded = getValues(FORM_NAMES.items)?.length;
    if (!isEmpty(offerData.items) && !preloaded) {
      const singleItem = offerData.items?.[0] as PriceItem;
      if (!singleItem) return;
      const singleFormItem = [
        {
          id: singleItem.id,
          quantity: 0,
          price: singleItem.price || 0,
          unit_type: singleItem.unit_type || UNIT_PRICE_TYPES.unit,
        },
      ];
      setValue(FORM_NAMES.items, singleFormItem, {
        shouldTouch: true,
        shouldValidate: true,
      });
    }
  }, [getValues, offerData.items, setValue]);

  return (
    <div>
      <OrderRow>
        <div className="rowName">{t('price')}</div>
        <div className="rowValue">
          <span className="newPrice">{`${price}${currency}`}&nbsp;</span>
          <span className="unitType">
            / {t(UNIT_PRICE_LABELS[unit_type || UNIT_PRICE_TYPES.unit])}
          </span>
        </div>
      </OrderRow>
      <OrderRow>
        <div className="rowName">
          {t(QUANTITY_LABELS[unit_type || UNIT_PRICE_TYPES.unit])}
        </div>
        <div className="rowValue">
          <Controller
            control={control}
            name={quantitySingleFieldName}
            render={({field: {ref, ...restField}}) => (
              <ControlledCounter disabled={disabled} {...restField} />
            )}
            rules={{required: t<string>('required')}}
          />
        </div>
      </OrderRow>
    </div>
  );
}

export default React.memo(SinglePriceForm);
